import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import GraphqlApi from '../../api-graphql';
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import { makeStyles, Paper, Grid, Button, LinearProgress, Typography } from '@material-ui/core';
import './styles.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

const useStyles = makeStyles(theme => ({
  paper: {
    maxWidth: '75%',
    margin: 'auto',
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      margin: 8,
      padding: 8
    }
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    fontSize: '1em',
    [theme.breakpoints.down('md')]: {
      padding: 0
    }
  },
  title: {
    marginBottom: 16
  },
  editorParent: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 16,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column'
    }
  },
  editorJsonSchema: {
    flex: '1 1 calc(50% - 8px)',
    maxWidth: 'calc(50% - 8px)',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      marginBottom: 16
    }
  }
}));

const TemplateEdit = (props) => {
  const { subgroup } = props;

  const [loading, setLoading] = useState(true);
  const [template, setTemplate] = useState();
  const [schema, setSchema] = useState();
  const [uischema, setUischema] = useState();

  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    async function init () {
      try {
        let result = await GraphqlApi.getTemplate(props.match.params.number);
        delete result.data.getTemplate.document;
        setTemplate(result.data.getTemplate);
        setSchema(JSON.parse(result.data.getTemplate.schema));
        setUischema(JSON.parse(result.data.getTemplate.uischema));
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }

    init();
  }, []);

  const handleChange = (schema) => {
    setSchema(schema);
  };

  const handleChangeDos = (uischema) => {
    setUischema(uischema);
  };

  const handleClick = async () => {
    setLoading(true);
    let input = template;
    input.schema = JSON.stringify(schema);
    input.uischema = JSON.stringify(uischema);

    await GraphqlApi.updateTemplate(input, subgroup)
      .then(() => props.history.push('/template'))
      .catch(error => console.error(error));

    setLoading(false);
  };

  if (loading) {
    return <LinearProgress />;
  }

  return (
    <main className={classes.content}>
      <Paper className={classes.paper}>
        <Grid>
          <Typography component='h3' variant='h5' className={classes.title}>
            {t('templateEdit:modifyJSONSchema')}
          </Typography>
          <div className={classes.editorParent}>
            <div className={classes.editorJsonSchema}>
              <Editor
                value={schema}
                onChange={handleChange}
              />
            </div>
            <div className={classes.editorJsonSchema}>
              <Editor
                value={uischema}
                onChange={handleChangeDos}
              />
            </div>
          </div>
          <Button variant='contained' color='primary' onClick={() => handleClick()} fullWidth>
            {t('templateEdit:save')}
          </Button>
        </Grid>
      </Paper>
    </main>
  );
};

TemplateEdit.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  subgroup: PropTypes.string.isRequired

};

const mapStateToProps = (state) => {
  return {
    subgroup: state.config.subgroup
  };
};

export default connect(mapStateToProps, null)(TemplateEdit);
